import { Button, Divider, Stack, Typography } from '@mui/material';
import { ComponentType, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';
import { TestsEditForm, TestsEditFormProps } from '../tests-edit-form';
import { TestsImportForm } from '../tests-import-form';

interface TestsEditDialogProps extends TestsEditFormProps {
  title?: string;
  popDialog?: any;
}

export const TestsEditDialog: ComponentType<TestsEditDialogProps> = ({
  title: dialogTitle,
  id,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const defaultTitle = !!id
    ? t('tests.edit', 'Редактировать тест')
    : t('tests.add', 'Добавление тестов');
  const title = dialogTitle ? dialogTitle : defaultTitle;

  const [type, setType] = useState<'manual' | 'upload'>('manual');
  const isUpload = type === 'upload';

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      {title && (
        <Typography variant="h2" component="h6" mb={2}>
          {title}
        </Typography>
      )}
      {!id && (
        <>
          <Stack direction="row" spacing={1}>
            <Button
              variant={!isUpload ? 'contained' : 'outlined'}
              color="primary"
              size="small"
              onClick={() => setType('manual')}
            >
              {t('add.manual', 'Добавить вручную')}
            </Button>
            <Button
              variant={isUpload ? 'contained' : 'outlined'}
              color="primary"
              size="small"
              onClick={() => setType('upload')}
            >
              {t('upload.file', 'Загрузить файл')}
            </Button>
          </Stack>
          <Divider sx={{ mt: 3, mb: 4 }} />
        </>
      )}

      {(id || !isUpload) && <TestsEditForm id={id} onSubmit={onSubmit} onCancel={popDialog} />}
      {isUpload && <TestsImportForm onCancel={popDialog} />}
    </BaseDialog>
  );
};
